










  import { Vue, Component } from 'vue-property-decorator';

  @Component({  
})
  export default class GenerateBtn extends  Vue{    
    generateProfiles(): void{
      this.$emit('generate-profiles')
    }
  }
